var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"party",class:{ "transparent-background": _vm.transparentBackground }},[_c('div',{staticClass:"absolute-wrap"},[_c('canvas',{ref:"partyCanvas"})]),_c('div',{staticClass:"absolute-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }